import React from 'react';
export const PlatformContext = React.createContext('web');
